export const EXTRA_TYPE_EXTRA = 2